import { useState } from 'react';

export const useCatalogMediaPreview = () => {
  const [selectedUrl, setSelectedUrl] = useState<string | null>(null);

  return {
    selectedUrl,
    openPreview: (url: string) => setSelectedUrl(url),
    closePreview: () => setSelectedUrl(null),
  };
};
